import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "@/data";
import { Reveal, Eyebrow } from "./Reveal";

const Stars = () => (
  <div className="flex gap-1">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-4 w-4 fill-[#d4af37] text-[#d4af37]" />)}
  </div>
);

export const Reviews = () => (
  <section id="opinioes" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36">
    <div className="grid gap-14 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>Opiniões</Eyebrow>
        <div data-testid="reviews-score" className="mt-8 font-serif text-[9rem] leading-none gold-text">5,0</div>
        <Stars />
        <p className="mt-4 text-zinc-300">12 críticas no Google</p>
        <p className="mt-6 max-w-xs text-sm text-zinc-400">O que as nossas clientes dizem sobre o espaço e o atendimento.</p>
      </Reveal>
      <div className="lg:col-span-8 grid gap-5 sm:grid-cols-2">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1} className={i === 0 ? "sm:col-span-2" : ""}>
            <motion.article
              data-testid={`review-card-${i}`}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className="h-full rounded-[4px] border border-white/10 bg-[#131315] p-7 transition-colors hover:border-[#d4af37]/50"
            >
              <Quote className="h-6 w-6 text-[#d4af37]" />
              <p className={`mt-5 font-serif leading-snug text-[#f5f2ea] ${i === 0 ? "text-2xl sm:text-3xl" : "text-xl"}`}>
                “{r.text}”
              </p>
              <div className="mt-6 flex items-center justify-between">
                <span className="text-sm text-zinc-300">{r.name}</span>
                <Stars />
              </div>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
